module.exports = __webpack_public_path__ + "img/ruanzhu2222.ecde07dc.png";